export enum SectionEnum {
  NatureOfBusiness = 'NATURE_OF_BUSINESS',
  ImpactsOnStakeholdersManagement = 'IMPACTS_ON_STAKEHOLDERS_MANAGEMENT',
  FinancialStatements = 'FINANCIAL_STATEMENTS',
  CvUpAndRiskMgmt = 'CV_UP_AND_RISK_MGMT',
  EsgPlatform = 'ESG_PLATFORM',
  EsgGreenHouse = 'ESG_GREENHOUSE',
  Summary = 'SUMMARY',
}
